import React from "react";
import "../../styles/AppDisclaimer.css";
// import { Button } from "@digitallabs/one-x-ui";
import { Button } from "../../resourses/digitallabs/one-x-ui";
import { redirectToLogin } from "../../utils/checkUserInactivity";
import { appRouter } from "../../constants/routerConstant";
import { getUserToken } from "../../utils/formStorage";

const AppDisclaimer = () => {
  const steps = [
    {
      id: 1,
      title: "Login",
      description: "Enter your Employee ID and Date of Birth on the login screen to start your questionnaire",
    },
    {
      id: 2,
      title: "Fill in Your Details",
      description: "Provide all required information accurately and ensure it reflects your current details as on the date of submission",
    },
    {
      id: 3,
      title: "Review & Confirm",
      description: "After completing the form, you’ll see a Confirmation Screen. Review everything carefully before moving ahead",
    },
    {
      id: 4,
      title: "Verify With OTP",
      description:
        "You’ll receive an OTP on your official email. Entering this OTP serves as your digital signature confirming all details are correct",
    },
    {
      id: 5,
      title: "Submit Successfully",
      description: "Once the OTP is verified, your form is officially submitted to our system",
    },
    {
      id: 6,
      title: "Response Saved",
      description: "A PDF copy of your submitted questionnaire will be emailed to you for your records",
    },
  ];

  const handleNavigateLogin = () => {
    const memberInformationToken = getUserToken();
    redirectToLogin(appRouter.DMQLogin, memberInformationToken);
  };

  return (
    <div className="disclaimer-container">
      <h2 className="disclaimer-title">How the process works</h2>
      <p className="disclaimer-subtext">
        Your medical questionnaire will be completed in a few simple steps. Follow the instructions below to understand the process.
      </p>

      {steps.map((step) => (
        <div className="step-box" key={step.id}>
          <div className="step-number-box">
            <span className="step-label">Step</span>
            <span className="step-number">{step.id}</span>
          </div>

          <div className="step-content">
            <h3 className="step-title">{step.title}</h3>
            <p className="step-desc">{step.description}</p>
          </div>
        </div>
      ))}

      <Button fullWidth size="md" variant="primary" onClick={handleNavigateLogin}>
        Back to Login
      </Button>
    </div>
  );
};

export default AppDisclaimer;
